import React from 'react';
import Dance from './Dance';

import { getLatestDance } from './AppUtils';

class DanceLatest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mounted: false,
      interval: null,
      timer: 10*1000,
      dance: null,
      danceId: null,
      update: null
    };

    this.startListener  = this.startListener.bind(this);
    this.getDance       = this.getDance.bind(this);
  }

  componentDidMount() {
    this.startListener();
  }

  componentWillUnmount(){
    clearInterval(this.state.interval);
  }

  startListener() {
    this.getDance();
    var interval = setInterval(function(){
      this.getDance();
    }.bind(this), this.state.timer);

    this.setState({interval: interval});
  }

  getDance() {
    getLatestDance()
      .then((success) => {
        //console.log(success);

        /*****

        look at the update time


        *****/

        if(this.state.update != success.updated_at) {
          console.log(success);
          console.log("UPDATE!");

          if(this.state.mounted) {
            location.reload();
          }

          this.setState({
            mounted: true,
            danceId: success._id,
            update: success.updated_at
          }, function(){
            this.forceUpdate();
          });
        }
      });
  }

  render() {
    return(
      <div className="full">
        <div className="table">
          <div className="table-cell">
            {this.state.mounted ?
            <Dance danceId={this.state.danceId} play={true} browse={false} respond={false} /> : null}
          </div>
        </div>
      </div>
    )
  }
}

export default DanceLatest;



// WEBPACK FOOTER //
// src/DanceLatest.js